'use client';

import { ErrorFallbackView } from '@/components/error-ui/error-fallback-view';

type ErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function RouteError({ reset }: ErrorPageProps) {
  return <ErrorFallbackView onRetry={reset} />;
}
